/* eslint-disable */
import { setBaseURL, setIntercept } from './../services/api'
import { trafficSystem } from './../services/trafficSystem'
import swal from 'sweetalert2'

export function initialize(store, router) {
  router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiresManager = to.matched.some(record => record.meta.requiresManager);
    const requiresAccessPowerUniversity = to.matched.some(record => record.meta.requiresAccessPowerUniversity);
    const currentUser = store.state.currentUser;    

    // Notification
    if (currentUser) { 
      if (currentUser.is_manager && to.path !== '/editar-perfil') {
        verifyManagerEmail(currentUser, router)
      }

      trafficSystem(to.path, router, store)
    }

    // Auth
    if (requiresAuth && !currentUser) {
      next('login');
    } else if (to.path == '/login' && currentUser) {
      next('/');
    } else if (requiresManager) { // To Manager
      if (currentUser.is_manager) {
        if (requiresAccessPowerUniversity) {
          if (checkAccessPowerUniversity(currentUser)) {
            next();
          } else {
            next('/');
          }
        } else {
          next();
        }
      } else {
        next('/');
      }
    } else {
      next();
    }
  });

  setBaseURL(); // API  
  setIntercept(store, router); // API

  if (store.getters.currentUser) {
    setAuthorization(store.getters.currentUser.token);
  }
}

export function setAuthorization(token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export function verifyManagerEmail(manager, router) {
  if (!manager.email) {
    swal({
      title: 'Caro(a) Gestor(a)!',
      text: 'Por favor complementar seu cadastro com e-mail e telefone.',
      type: 'warning',
      showCancelButton: false,
      confirmButtonClass: 'btn btn-info btn-fill',
      confirmButtonText: 'OK',
      buttonsStyling: false,
      allowOutsideClick: false,
      preConfirm: () => {
        return (new Promise((resolve, reject) => {
          resolve('OK')
        }))
      }
    }).then(() => {
      router.push(`/editar-perfil`)
    }).catch(swal.noop)
  }
}

export function validCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf == '') return false;
  // Elimina CPFs invalidos conhecidos
  if (cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999")
    return false;
  // Valida 1o digito
  var add = 0;
  for (var i = 0; i < 9; i++)
    add += parseInt(cpf.charAt(i)) * (10 - i)
  var rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
    rev = 0;
  if (rev != parseInt(cpf.charAt(9)))
    return false;

  // Valida 2o digito
  add = 0;
  for (var i = 0; i < 10; i++)
    add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11);
  rev = 0;
  if (rev != parseInt(cpf.charAt(10)))
    return false;
  return true;
}

export function getNumber(str) {
  return str.replace(/[^0-9]/g, '');
}

export function readOrientation (file) {
  return (new Promise(resolve => {
    const reader = new FileReader();

    reader.onload = () => resolve((() => {
      const view = new DataView(reader.result);

      if (view.getUint16(0, false) !== 0xFFD8) {
        return;
      }

      const length = view.byteLength;
      let offset = 2;

      while (offset < length) {
        const marker = view.getUint16(offset, false);
        offset += 2;

        if (marker == 0xFFE1) {
          offset += 2;

          if (view.getUint32(offset, false) !== 0x45786966) {
            return;
          }

          offset += 6;
          const little = view.getUint16(offset, false) === 0x4949;

          offset += view.getUint32(offset + 4, little);

          const tags = view.getUint16(offset, little);

          offset += 2;

          for (var i = 0; i < tags; i++) {
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              return view.getUint16(offset + (i * 12) + 8, little);
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) {
          break;
        } else {
          offset += view.getUint16(offset, false);
        }
      }

    })());

    reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
  }));
}

export function checkAccessPowerUniversity(user) {
  const companyCods = ['60.000.001']
  const userCompanyCod = user.position.department.company.cod

  return companyCods.includes(userCompanyCod)
}


// WEBPACK FOOTER //
// ./src/helpers/general.js